// extracted by mini-css-extract-plugin
export default {"wishlistButton":"wishlist_wishlistButton__eQIyZ"};